<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{ name: 'index' }">首页</router-link>>
          <router-link :to="{ name: 'user-center' }">个人中心</router-link>>
          修改密码
        </div>
        <left-userinfo></left-userinfo>
        <div class="right-user-wrap">
          <div class="title">
            <h2>修改密码</h2>
          </div>
          <ul class="info-body">
            <li>
              <span>账号邮箱</span>
              {{ userInfo.email }}
            </li>
            <li>
              <span>验证码</span>
              <el-input
                placeholder="请输入验证码"
                v-model="form.token"
              ></el-input>
              <div class="text yzm" @click="getYzm">
                {{ yzmTime === 0 ? "获取验证码" : +yzmTime + "s后获取" }}
              </div>
            </li>
            <li>
              <span>新密码</span>
              <el-input
                placeholder="请输入新密码"
                v-model="form.new_password"
                show-password
              ></el-input>
              <div class="text">
                请输入6-20位数字、字母（区分大小写）或符号（除空格）且数字、字母和符号至少包含两种
              </div>
            </li>
            <li>
              <span>新密码</span>
              <el-input
                placeholder="请再次输入新密码"
                v-model="newpassword2"
                show-password
              ></el-input>
            </li>
            <li>
              <span></span>
              <el-button @click="cancel" style="width: 95px">取消</el-button>
              <el-button
                style="width: 95px; color: #fff"
                @click="forget"
                :style="
                  oButton
                    ? 'background-color:#FF4D4F'
                    : 'background-color:#CCCCCC'
                "
                >更改密码</el-button
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo
  },
  data() {
    return {
      newpassword2: "",
      form: { username: "", token: "", new_password: "", type: "email" },
      yzmTime: 0,
      userInfo: {},
      avatar: ""
    };
  },
  mounted() {
    this.getData();
    this.getActivity();
  },
  computed: {
    oButton() {
      if (
        this.form.username &&
        this.form.token &&
        this.form.new_password &&
        this.newpassword2
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    open(mes) {
      this.$message({
        message: mes,
        type: "warning"
      });
    },
    getData() {
      this.$reqGet("api/usercenter/info").then(res => {
        this.userInfo = res.data.data;
        this.form.username = this.userInfo.email;
        if (this.userInfo.companyInfo && this.userInfo.companyInfo.avatar) {
          this.avatar = this.userInfo.companyInfo.avatar;
        }
      });
    },
    getActivity() {
      let activityId = sessionStorage.getItem("activityId");
      this.$reqGet("api/store/activities/" + activityId).then(res => {
        let allow_change_password =
          res.data.data.products.allow_change_password;
        if (!allow_change_password) {
          this.$router.replace({ path: "/" });
        }
      });
    },
    getYzm() {
      if (this.yzmTime !== 0) {
        return;
      }
      if (!this.form.username) {
        this.open("请先输入邮箱");
      }
      this.$reqPost(
        "api/store/send_edit_password_mail?access_token=" + this.form.username,
        {
          email: this.form.username
        }
      ).then(res => {
        this.$message({
          message: "验证码发送成功",
          type: "success"
        });
        if (res.data.success) {
          this.yzmTime = 60;
          let clock = setInterval(() => {
            if (this.yzmTime > 0) {
              this.yzmTime--;
            } else {
              clearInterval(clock);
            }
          }, 1000);
        }
      });
    },
    cancel() {
      this.$router.back();
    },
    forget() {
      if (!this.form.username) {
        this.open("请输入邮箱账号");
        return;
      }
      if (!this.form.new_password || !this.newpassword2) {
        this.open("请输入新密码");
        return;
      }
      if (!this.form.token) {
        this.open("请输入验证码");
        return;
      }
      if (this.newpassword2 !== this.form.new_password) {
        this.open("两次输入密码不相等，请重新输入");
        return;
      }
      let Rep = /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-zA-Z]|[0-9]){6,20}$/.test(
        this.form.new_password
      );
      if (!Rep) {
        this.open(
          "密码不符合，请输入6-20位数字、字母（区分大小写）或符号（除空格）且数字、字母和符号至少包含两种"
        );
        return;
      }
      if (/\s/.test(this.form.new_password)) {
        this.open(
          "密码不符合，请输入6-20位数字、字母（区分大小写）或符号（除空格）且数字、字母和符号至少包含两种"
        );
        return;
      }
      this.$confirm("确认更改密码吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$reqPost(
            "api/usercenter/changePasswordByCode?access_token=" +
              this.form.username,
            {
              ...this.form,
              force: true
            }
          ).then(res => {
            if (res.data.success) {
              this.open("密码修改成功！");
              this.form = {};
              this.newpassword2 = "";
              setTimeout(() => {
                this.$router.back();
              }, 500);
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right-user-wrap {
  // position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  margin-left: 220px;
  box-sizing: border-box;
  padding: 10px 25px 0;
  background-color: #fff;
  .title {
    line-height: 42px;
    height: 42px;
    border-bottom: 2px solid #dadada;
    margin-bottom: 30px;
    h2 {
      display: inline-block;
      border-bottom: 2px solid #e2333f;
      font-size: 20px;
      font-weight: normal;
      margin: 0;
      box-sizing: border-box;
      padding: 0 20px;
    }
  }
  .info-body {
    li {
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      span {
        display: block;
        width: 60px;
        text-align-last: justify;
        margin-right: 40px;
      }
      .el-input {
        width: 200px;
      }
      .text {
        margin-left: 20px;
        width: 400px;
      }
      .yzm {
        color: #fc0010;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/change-password.vue